module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "fluid": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": "",
      "offset-sm2": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    staticClass: "primary"
  }, [_c('v-toolbar-title', {
    staticClass: "white--text"
  }, [_vm._v("Total Ventas")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Desde",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fechainicio),
      callback: function($$v) {
        _vm.fechainicio = $$v
      },
      expression: "fechainicio"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.fechainicio),
      callback: function($$v) {
        _vm.fechainicio = $$v
      },
      expression: "fechainicio"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu2),
      callback: function($$v) {
        _vm.menu2 = $$v
      },
      expression: "menu2"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Hasta",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.fechafin),
      callback: function($$v) {
        _vm.fechafin = $$v
      },
      expression: "fechafin"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return save()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.fechafin),
      callback: function($$v) {
        _vm.fechafin = $$v
      },
      expression: "fechafin"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "green--text",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.mostrar
    }
  }, [_vm._v("\n                  Mostrar"), _c('v-icon', [_vm._v("find_in_page")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_c('b', [_vm._v("Lista")])]), _vm._v(" "), _c('th', [_c('b', [_vm._v("Total:")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.resultado), function(dato) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(dato.nombrelista))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(parseFloat(dato.total).toLocaleString('es-GT')))])])
  }), 0)])])], 1)], 1)], 1), _vm._v(" "), _c('v-layout')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a651c93"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReporteVentas.vue
// module id = 426
// module chunks = 1